import React, { useState } from "react";
import Swal from "sweetalert2";
import { FieldArray, useFormikContext } from "formik";
import { Table } from "react-bootstrap";
import { DialogActions } from "@material-ui/core";
import Illustration from "../../../../../partials/content/Illustration";
import { FormArrayTextField } from "../../../../../partials/content/Forms/FormField";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchVariant from "../../../inventory/items/searchVariant";
import SearchItemUom from "../../../inventory/items/searchItemUom";

function ItemSellVarDetailFormContent({ selectedItem = {}, onCloseDialog }) {
  const { values, setFieldValue, handleSubmit } = useFormikContext();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [openSearchVariant, setOpenSearchVariant] = useState(false);
  const [openSearchUom, setOpenSearchUom] = useState(false);
  return (
    <React.Fragment>
      <FieldArray name="data">
        {({ push, remove }) => (
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="card">
                <Table borderless size="sm" responsive="xl">
                  {values.data && values.data.length > 0 ? (
                    <thead className="text-center">
                      <tr>
                        <th style={{ width: "50%" }}>Variant</th>
                        <th style={{ width: "20%" }}>Unit</th>
                        <th style={{ width: "25%" }}>Outlet Price</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                  ) : null}
                  <tbody>
                    {values.data && values.data.length > 0 ? (
                      values.data.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <FormArrayTextField
                                arrayPropName="data"
                                index={index}
                                propName="itemName"
                                margin="none"
                                value={item.itemName}
                                searchButton
                                clearButton
                                readonly
                                onSearchClick={() => {
                                  setSelectedIndex(index);
                                  setOpenSearchVariant(true);
                                }}
                                onClearFields={() => {
                                  setFieldValue(
                                    `data[${index}].itemName`,
                                    "No Variant"
                                  );
                                  setFieldValue(`data[${index}].varCode`, "");
                                }}
                              />
                            </td>
                            <td>
                              <FormArrayTextField
                                arrayPropName="data"
                                index={index}
                                propName="uomName"
                                margin="none"
                                value={item.uomName}
                                searchButton
                                readonly
                                onSearchClick={() => {
                                  setSelectedIndex(index);
                                  setOpenSearchUom(true);
                                }}
                              />
                            </td>
                            <td>
                              <FormArrayTextField
                                arrayPropName="data"
                                index={index}
                                propName="outletPrice"
                                margin="none"
                                value={item.outletPrice}
                                currencyField
                              />
                            </td>
                            <td
                              style={{ whiteSpace: "nowrap" }}
                              className="text-center"
                            >
                              <BootstrapTooltip
                                title={
                                  item.deleteInd
                                    ? "Undo Delete"
                                    : "Delete Alternative Variant Unit Price Item"
                                }
                              >
                                <button
                                  type="button"
                                  className={`btn btn-icon btn-label-${
                                    item.deleteInd ? "warning" : "danger"
                                  } btn-md btn-circle mx-1`}
                                  onClick={() => {
                                    if (item.ID > 0) {
                                      const itemVariantsTmp = [...values.data];
                                      itemVariantsTmp[
                                        index
                                      ].deleteInd = !item.deleteInd;
                                      setFieldValue("data", itemVariantsTmp);
                                    } else {
                                      remove(index);
                                    }
                                  }}
                                >
                                  {item.deleteInd ? (
                                    <i className="fas fa-undo-alt"></i>
                                  ) : (
                                    <i className="fas fa-trash-alt"></i>
                                  )}
                                </button>
                              </BootstrapTooltip>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td className="text-center py-3" colSpan="4">
                          <Illustration
                            imageSource="INVIFO Sales.png"
                            guidance="You don't have any Alternative Variant Unit Prices for this item
                          yet"
                            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                            size="sm"
                          ></Illustration>
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td className="text-center py-3" colSpan="4">
                        <button
                          type="button"
                          className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                          onClick={() => {
                            push({
                              outletID: selectedItem.outletID,
                              itemID: selectedItem.itemID,
                              varCode: "",
                              itemName: "No Variant",
                              uomID: 0,
                              uomName: "",
                              outletPrice: 0,
                              deleteInd: false,
                            });
                          }}
                        >
                          <i className="fas fa-plus-circle"></i>
                          Add Alternative Variant Unit Price
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        )}
      </FieldArray>
      <DialogLayout
        open={openSearchVariant}
        title={`Search Variant`}
        onCloseDialog={() => {
          setOpenSearchVariant(false);
        }}
        maxWIdth="sm"
      >
        <SearchVariant
          itemID={selectedItem.itemID}
          onSelectVariant={(varCode, valueName) => {
            setFieldValue(`data[${selectedIndex}].varCode`, varCode);
            setFieldValue(`data[${selectedIndex}].itemName`, valueName);
            setOpenSearchVariant(false);
          }}
          onCloseDialog={() => {
            setOpenSearchVariant(false);
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openSearchUom}
        title="Search Unit of Measurement"
        onCloseDialog={() => {
          setOpenSearchUom(false);
        }}
        maxWIdth="sm"
      >
        <SearchItemUom
          itemID={selectedItem.itemID}
          onSelectUom={(uom) => {
            if (
              values.data[selectedIndex].varCode === "" &&
              uom.ID === selectedItem.uomID
            ) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Failed",
                text:
                  "Unable to select item Base Unit with No Variant combination. Please pick any Variant first before select item Base Unit",
                icon: "error",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            } else {
              setFieldValue(`data[${selectedIndex}].uomID`, uom.ID);
              setFieldValue(`data[${selectedIndex}].uomName`, uom.uomName);
            }
            setOpenSearchUom(false);
          }}
          onCloseDialog={() => {
            setOpenSearchUom(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchUom(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            onCloseDialog();
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
        {values.data && values.data.length > 0 ? (
          <button
            type="submit"
            className="btn btn-success btn-md btn-pill btn-bold"
            onSubmit={handleSubmit}
          >
            <i className="fas fa-save"></i>
            Save
          </button>
        ) : null}
      </DialogActions>
    </React.Fragment>
  );
}

export default ItemSellVarDetailFormContent;
